import React, { Fragment } from 'react';

import { 
  BulmaHero 
} from '../../components/HelperComponents/HelperComponents';

import {
  ThankYouH1,
  ThankYouH2,
  PrimaryButton
} from '../../components/HelperComponents/StyledComponents';

import BackgroundImage from '../../images/background.png';

const HeroBody = () => (
  <Fragment>
    <section className="container">
      <section className="columns is-centered">
        <section className="column is-6 has-text-white">
          <ThankYouH1 className="title is-1 has-text-white">Thank You,</ThankYouH1>
          <ThankYouH2 className="is-size-4">We will contact you shortly!</ThankYouH2>
          <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Atque voluptatem, tempora, quisquam obcaecati expedita harum optio soluta doloremque dicta officiis iusto magnam quas incidunt aliquid placeat! Repellat labore sint illo.</p>
          <PrimaryButton className="button is-rounded">Continue Shopping</PrimaryButton>
        </section>
      </section>
    </section>
  </Fragment>
);

export const ThankYou = () => (
  <BulmaHero heroSize="is-fullheight" body={<HeroBody />} image={BackgroundImage}></BulmaHero>
);



// WEBPACK FOOTER //
// ./src/routes/ThankYou/ThankYou.js